import { all, fork } from '@redux-saga/core/effects';
import bhajanSagas from './bhajanSagas';

export default function* rootSaga() {
  yield all([fork(bhajanSagas)]);
}
